import * as Sentry from '@sentry/gatsby';
import { routes } from 'constants/routes';
import { navigate } from 'gatsby';
import qs from 'qs';
import { url_users } from 'utils/api/user';
import { getAccess } from 'utils/hooks/storage/storageGets';
import { resetAnimatorAuth, resetOperatorAuth, resetWindow,setUserAuth } from 'utils/hooks/storage/storageSets';

// const uninstallWorkers = async () => {
// 	const registrations = await navigator.serviceWorker.getRegistrations();
// 	await Promise.all(registrations.map((registration) => registration.unregister()));
// };

// const clearCache = async () => {
// 	const keyList = await caches.keys();
// 	await Promise.all(keyList.map((key) => caches.delete(key)));
// };

export const signOut = async () => {
	const { token, scope } = getAccess();

	try {
		const url = `${process.env.GATSBY_BACKEND_URL}/${url_users.revoke_token}`;
		const data = qs.stringify({
			token: token,
			client_id: process.env.GATSBY_CLIENT_ID
		});
		
		const blob = new Blob([data], { type: 'application/x-www-form-urlencoded' });
		navigator.sendBeacon(url, blob);
	} catch(e) {
		Sentry.captureException(e);
	}

	if(scope === 'animator') {
		resetAnimatorAuth();
	}
	if(scope === 'operator') {
		resetOperatorAuth();
	}
	resetWindow();
	navigate(routes.SIGN_IN);
};

const authentication = service => ({
	signIn: ({ username, password }) =>
		service.post(url_users.auth_token,
			qs.stringify({
				username,
				password,
				grant_type: 'password',
				client_id: process.env.GATSBY_CLIENT_ID
			}),
			{
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded'
				}
			}
		).then(response => {
			setUserAuth(response);
			return response;
		})
});

export default authentication;
